import { TanstackQueryLoadingWrapper, TanstackQueryLoadingWrapperProps } from '@shared/components';
import { ErrorFallback } from '../ErrorFallback';
import React from 'react';

export function RetailTanstackQueryLoadingWrapper<TData>({
  ErrorComponent = ({ error, reload }) => <ErrorFallback message={error} resetError={reload} />,
  getErrorMessage = (error) =>
    error.payload?.error ?? error.payload?.detail ?? error.payload?.message,
  ...props
}: TanstackQueryLoadingWrapperProps<TData>) {
  return (
    <TanstackQueryLoadingWrapper
      {...props}
      getErrorMessage={getErrorMessage}
      ErrorComponent={ErrorComponent}
    />
  );
}
